import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useNavigate } from '~/components/utils/Navigation';
import { withAuthenticationRequired } from '~/lib/auth';

export type IAuthenticationGuardProps = {
  component: React.ReactElement;
};

export const AuthenticationGuard: React.FC<IAuthenticationGuardProps> = ({
  component,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const appRegion = searchParams.get('appRegion') || undefined;

  const Component = useMemo(
    () =>
      withAuthenticationRequired(component, {
        logInOptions: {
          openUrl: (url) => {
            navigate(url, { replace: true });
          },
          appRegion,
        },
      }),
    [component, navigate, appRegion],
  );

  return <Component />;
};
